import { Component } from "react";

export class ErrorBoundary extends Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    console.error("App error:", error);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-6 text-center" data-testid="app-error-screen">
        <p className="text-lg font-semibold text-slate-800">Algo travou nesta tela.</p>
        <p className="max-w-sm text-sm text-slate-500">Seus dados estão salvos. Recarregue para continuar de onde parou.</p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="rounded-full bg-slate-900 px-6 py-2 text-sm font-medium text-white transition-colors hover:bg-slate-700"
          data-testid="app-error-reload-btn"
        >
          Recarregar
        </button>
      </div>
    );
  }
}
